import { useEffect } from "react";
import "./GoogleReviews.css";

const GoogleReviews = () => {
  useEffect(() => {
    // Load Shapo script dynamically when component mounts
    const script = document.createElement("script");
    script.id = "shapo-embed-js";
    script.src = "https://cdn.shapo.io/js/embed.js";
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount if needed
      document.getElementById("shapo-embed-js")?.remove();
    };
  }, []);

  return (
    <section className="google-reviews">
      <div className="google-reviews__container">
        <div className="google-reviews__header">
          <h2 className="google-reviews__title">What Our Customers Say</h2>
          <div className="google-reviews__google-badge">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/272px-Google_2015_logo.svg.png"
              alt="Google"
              className="google-reviews__google-logo"
            />
            <div className="google-reviews__rating-summary">
              <span className="google-reviews__rating-text">
                Based on Google Reviews
              </span>
            </div>
          </div>
        </div>

        <div className="google-reviews__widget">
          <div id="shapo-widget-af823c82afbef0e24030"></div>
        </div>

        <div className="google-reviews__cta">
          <a
            href="https://www.google.com/maps/place/Respected+Solutions,+Lekki+Phase+1+Branch/@6.4385511,3.4617094,17z/data=!4m8!3m7!1s0x103bf5efc48854b7:0x2417dfad90386f6f!8m2!3d6.4385458!4d3.4642843!9m1!1b1!16s%2Fg%2F11xgnz6021?entry=ttu&g_ep=EgoyMDI1MDkxMC4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            className="google-reviews__view-all"
          >
            View All Google Reviews
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
